export default "__VITE_ASSET__D3hMYwAc__"